import { ChangeDetectionStrategy, Component, HostBinding, Input, input } from '@angular/core';
import { truncate } from 'lodash-es';
import { MenuItem } from '@openng/optimus-ui/api';

@Component({
  selector: 'page-settings-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbsComponent {
  @Input()
  set breadcrumbs(v: any[]) {
    // Úvodní položka je textový odkaz „Úvod“ místo ikony domečku – řada má vždy aspoň dvě položky (vzor AISK)
    const items = v.map((item, index) =>
      index === 0 && item.icon ? { ...item, icon: undefined, label: 'Úvod' } : item
    );
    this._breadcrumbs = items.map((item, index) => {
      if (index === items.length - 1)
        return {
          ...item,
          styleClass: item.label && item.label.length > 20 ? 'menuitem-break' : '',
          routerLink: null,
          label: truncate(item.label ?? '', { length: 40 }),
        };
      return {
        ...item,
        styleClass: item.label && item.label.length > 20 ? 'menuitem-break' : '',
        label: truncate(item.label ?? '', { length: 40 }),
      };
    });
  }
  get breadcrumbs() {
    return this._breadcrumbs;
  }

  readonly styleClass = input('');

  @HostBinding('class')
  get getClass() {
    return this.styleClass();
  }

  private _breadcrumbs: MenuItem[] = [];
}
